import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";

export interface IParamValuesDataTableRowFormMeta {

    id: FormInputMeta;
    label: FormInputMeta;
    defaultValue: FormInputMeta;
    minValue: FormInputMeta;
    maxValue: FormInputMeta;
    value: FormInputMeta;
    // value2: FormInputMeta;

    schema: any;
}

const paramValuesDataTableRowFormMeta = {} as IParamValuesDataTableRowFormMeta;

paramValuesDataTableRowFormMeta.id = {
    name: "id",
    type: "select",
    label: "Id",
    placeholder: "Veuillez choisir l'Id",
    validation: yup.string().required("Champ obligatoire !")
};
  
paramValuesDataTableRowFormMeta.label = {
    name: "label",
    type: "text",
    label: "Label",
    placeholder: "Veuillez choisir le label",
    validation: yup.string().required("Champ obligatoire !")
};
  
// Enhanced parameter tab table modal form fields
paramValuesDataTableRowFormMeta.defaultValue = {
    name: "defaultValue",
    type: "text",
    label: "Default Value",
    placeholder: "Veuillez choisir la valeur par défaut",
    validation: yup.string().required("Champ obligatoire !")
};
   
paramValuesDataTableRowFormMeta.minValue = {
    name: "minValue",
    type: "text",
    label: "Min Value",
    placeholder: "Veuillez choisir la valeur minimale",
    validation: yup.string().required("Champ obligatoire !")
};
   
paramValuesDataTableRowFormMeta.maxValue = {
    name: "maxValue",
    type: "text",
    label: "Min Value",
    placeholder: "Veuillez choisir la valeur maximale",
    validation: yup.string().required("Champ obligatoire !")
};
   
paramValuesDataTableRowFormMeta.value = {
    name: "value",
    type: "select",
    label: "Value",
    placeholder: "Veuillez choisir la valeur",
    validation: yup.string().required("Champ obligatoire !")
};

// Time parameter tab table modal form fields
// paramValuesDataTableRowFormMeta.value2 = {
//     name: "value2",
//     type: "text",
//     label: "Value",
//     placeholder: "Veuillez choisir la valeur",
//     validation: yup.string().required("Champ obligatoire !")
// };
   

paramValuesDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(paramValuesDataTableRowFormMeta));

export default paramValuesDataTableRowFormMeta; 